<template>
    <div class="relative w-full max-w-full h-full">
        <video :src="src" :poster="poster" :controls="controls" :autoplay="autoplay" :loop="loop" :muted="muted"
            class="w-full h-full block rounded-md">
            Your browser does not support the video tag.
        </video>
    </div>
</template>

<script>
export default {
    name: 'VideoPlayer',
    props: {
        src: {
            type: String,
            required: true
        },
        poster: {
            type: String,
            default: ''
        },
        controls: {
            type: Boolean,
            default: true
        },
        autoplay: {
            type: Boolean,
            default: false
        },
        loop: {
            type: Boolean,
            default: false
        },
        muted: {
            type: Boolean,
            default: false
        }
    }
}
</script>
